<template>
    <div>
      <b-modal id="modalTelephoneOperators" ref="modalTelephoneOperators" :title="$t('Telephone operator')" hide-footer size="xl" @shown="shown">
        <div v-if="editItem">
          <b-tabs pills card>
            <b-tab :title="$t('Supplier details')">
              <b-tabs pills card>
                <b-tab :title="$t('Company')">
                  <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
                    <b-form-invalid-feedback id="inputFeedbackName">
                        {{ $t('Enter title') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Short name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.short_name"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Legal address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.jur_adress"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Actual address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.act_adress"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('ITIN')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.inn"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Reg code')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.kpp"/>
                  </b-form-group>
                </b-tab>
                <b-tab :title="$t('Excutive managers')">
                  <b-form-group label-align="right" :label="$t('CEO')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.headman"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Accountant')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.bookeeper"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Short name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.short_headman"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Short name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.short_bookeeper"/>
                  </b-form-group>
                </b-tab>
                <b-tab :title="$t('Bank')">
                  <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="bank.name" disabled/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('City')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="bank.city" disabled/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('BIN')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="bank.bic" disabled/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Correspondent account')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="bank.kschet" disabled/>
                  </b-form-group>
                  <b-button variant="secondary" size="sm" @click="showBank">{{ $t('Select bank') }}</b-button>
                  <b-form-group label-align="right" :label="$t('Personal account')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.account"/>
                  </b-form-group>
                </b-tab>
                <b-tab :title="$t('Contract')">
                  <b-form-group label-align="right" :label="$t('Contract number')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.contract_number"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Contract place')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.contract_place"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Number format')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.number_format"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Client prefix')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.client_prefix"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Service place')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.service_place"/>
                  </b-form-group>
                </b-tab>
              </b-tabs>
            </b-tab>
            <b-tab :title="$t('Supplier balance')">
              <b-form-group label-align="right" :label="$t('Balance')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="editItem.balance" disabled/>
              </b-form-group>
              <b-button size="sm" variant="secondary" :disabled="editItem.id === 0" @click="showPayment">{{ $t('Make payyment') }}</b-button>
            </b-tab>
            <b-tab :title="$t('Service parameters')">
              <b-form-group label-align="right" :label="$t('Free time')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="serviceParam.tel_service_data.cost_info.free_time" type="number"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Starting period lenght')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="serviceParam.tel_service_data.cost_info.first_period_length" type="number"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Starting period step')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="serviceParam.tel_service_data.cost_info.first_period_step" type="number"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Next period step')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="serviceParam.tel_service_data.cost_info.second_period_step" type="number"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Tariffcication unit size')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="serviceParam.tel_service_data.cost_info.time_unit_size" type="number"/>
              </b-form-group>
            </b-tab>
            <b-tab :title="$t('Price editor')">
              <b-form-group>
                <b-button size="sm" class="mt-2" variant="success" @click="showAddTimeRange">{{ $t('Add time range') }}</b-button>
                <b-button size="sm" class="mt-2" variant="success" @click="showAddTelDirections">{{ $t('Add direction') }}</b-button>
                <b-button size="sm" class="mt-2" variant="success" @click="showAddTelZones">{{ $t('Add zone') }}</b-button>
              </b-form-group>

              <b-row>
                <b-col id="grayBorder">
                  {{ $t('Direction/zone') }}
                </b-col>
                <b-col id="grayBorder" v-for="item in costTimeRange" :key="item.time_range_id">
                  <b-row>
                    <b-col cols="7" >
                      {{ item.nameTimeRange }}
                    </b-col>
                    <b-col cols="5" style="padding-left:0px;padding-right:0px;">
                      <b-button size="sm" id="transparent" @click="deleteTimeRange(item)">
                        <b-img :src='deleteImage'/>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col id="grayBorder">
                </b-col>
              </b-row>

              <b-row v-for="item in costTable" :key="item.tariff_key">
                <b-col id="grayBorder">
                  {{ item.nameTel }}
                </b-col>
                <b-col id="grayBorder" v-for="itemd in item.cost_info.costs" :key="itemd.time_range_id">
                  <b-form-input v-model="itemd.cost"/>
                </b-col>
                <b-col id="grayBorder">
                  <b-button size="sm" id="transparent" @click="deleteCost(item)">
                    <b-img :src='deleteImage'/>
                  </b-button>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab :title="$t('Tariffication borders')">
              <b-button size="sm" variant="success" @click="showAddTelDirBorder">{{ $t('Add direction') }}</b-button>
              <b-button size="sm" variant="success" @click="showAddTelZonesBorder">{{ $t('Add zone') }}</b-button>
              <b-col class="mt-3"/>
              <b-card>
                <b-row>
                  <b-col>
                    <h4>{{ $t('Direction/zone') }}</h4>
                  </b-col>
                  <b-col>
                    <h4>{{ $t('Border') }}</h4>
                  </b-col>
                  <b-col>
                    <h4>{{ $t('Coefficient') }}</h4>
                  </b-col>
                  <b-col>
                    <h4>{{ $t('Actions') }}</h4>
                  </b-col>
                </b-row>

                <div v-for="item in costTable" v-bind:key="item.tariff_key">
                  <b-row v-for="itemBorder in item.cost_info.borders" v-bind:key="itemBorder.num">
                    <b-col>
                      <h4>{{ item.nameTel }}</h4>
                    </b-col>
                    <b-col>
                      <b-form-input type="number" v-model="itemBorder.border"/>
                    </b-col>
                    <b-col>
                      <b-form-input type="number" v-model="itemBorder.cost_coefficient"/>
                    </b-col>
                    <b-col>
                      <b-button size="sm" id="transparent" @click="deleteBorder(itemBorder, item.tariff_key)">
                        <b-img :src='deleteImage'/>
                      </b-button>
                    </b-col>
                  </b-row>
                </div>

              </b-card>
            </b-tab>
            <b-tab :title="$t('Fixed cost')">
              <b-button size="sm" variant="success" @click="showAddTelDirFixed">{{ $t('Add direction') }}</b-button>
              <b-button size="sm" variant="success" @click="showAddTelZonesFixed">{{ $t('Add zone') }}</b-button>
              <b-col class="mt-3"/>

              <b-card>
                <b-row>
                  <b-col>
                    <h4>{{ $t('Direction/zone') }}</h4>
                  </b-col>
                  <b-col>
                    <h4>{{ $t('Value') }}</h4>
                  </b-col>
                  <b-col>
                    <h4>{{ $t('Actions') }}</h4>
                  </b-col>
                </b-row>
                <b-row v-for="item in fixedRoll" v-bind:key="item.tariff_key">
                  <b-col>
                    <h4>{{ item.nameTel }}</h4>
                  </b-col>
                  <b-col>
                    <b-form-input type="number" v-model="item.cost_info.fixed_cost"/>
                  </b-col>
                  <b-col>
                    <b-button size="sm" id="transparent" @click="deleteFixed(item)">
                      <b-img :src='deleteImage'/>
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-tab>
            <b-tab :title="$t('Reports')" v-if="editItem.id > 0">
              <b-tabs pills card>
                <b-tab :title="$t('Supplier payments report')">
                  <reportPayment :editItem="editItem"/>
                </b-tab>
                <b-tab :title="$t('Supplier charges report')">
                  <reportCharges :editItem="editItem"/>
                </b-tab>
              </b-tabs>
            </b-tab>
            <b-tab :title="$t('Beeline reports')" v-if="editItem.id > 0">
              <b-tabs pills card>
                <b-tab :title="$t('Supplier users report')">
                  <reportUsers :editItem="editItem"/>
                </b-tab>
                <b-tab :title="$t('Supplier invoices report')">
                  <reportInvoices :editItem="editItem"/>
                </b-tab>
              </b-tabs>
            </b-tab>
          </b-tabs>

          <b-row>
            <b-col>
              <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">Ok</b-button>
            </b-col>
            <b-col sm="1.5">
              <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalTelephoneOperators.hide">{{ $t('Cancel') }}</b-button>
            </b-col>
          </b-row>
        </div>
      </b-modal>

      <b-modal id="modalBank" ref="modalBank" :title="$t('Banks')" hide-footer>
        <b-table striped hover small
          :items="banks"
          :fields="banksFields"
          selectable
          @row-selected="onRowSelected"
          select-mode="single">
        </b-table>
        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="selectBank">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalBank.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </b-modal>

      <b-modal id="modalPayment" ref="modalPayment" :title="$t('Payment')" hide-footer size="lg">
        <b-form-group label-align="right" label='ID' label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="payment.id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="payment.name" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Sum')" :disabled="payment.isResetBalance" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="payment.sum"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Currency')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="currencies" v-model="payment.currency"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Reason for payment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="payment.reason"/>
        </b-form-group>
        <b-checkbox v-model="payment.isResetBalance" @change.stop="resetBalance">{{ $t('Reset balance') }}</b-checkbox>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="savePayment">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalPayment.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </b-modal>

      <b-modal hide-footer :title="$t('Time range')" ref="modalTimeRange" size="lg">
        <b-table striped hover
        :items="timeRangeList"
        :fields="timeRangeFields"
        selectable
        select-mode="single"
        @row-clicked="rowClickTimeRange">
        </b-table>
        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addTimeRange">Ok</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalTimeRange.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </b-modal>

      <b-modal hide-footer :title="$t('Telephone directions')" ref="modalTelDirections" size="lg">
        <b-table striped hover id="tablereport" responsive
        :items="telDirectionsItems"
        :fields="telDirectionsFields"
        selectable
        select-mode="single"
        @row-clicked="rowClickTelDirections">
        </b-table>
        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addTelDirections">Ok</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalTelDirections.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </b-modal>

      <b-modal hide-footer :title="$t('Telephone zones')" ref="modalTelZones" size="lg">
      <b-table striped hover
      :items="telZonesItems"
      :fields="telZonesFields"
      selectable
      select-mode="single"
      @row-clicked="rowClickTelZones">
      </b-table>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addTelZones">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalTelZones.hide">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>
    </div>
</template>

<script>
import reportPayment from './reportPayment'
import reportCharges from './reportCharges'
import reportUsers from './reportUsers'
import reportInvoices from './reportInvoices'

export default {
  components: {
    reportPayment,
    reportCharges,
    reportUsers,
    reportInvoices
  },
  props: {
    editItem: null
  },
  data () {
    return {
      borId: 0,
      fixedRoll: [],
      costTable: [],
      isBorder: false,
      isFixed: false,
      rowTelZones: null,
      rowTelDirections: null,
      rowTimeRange: null,
      costTimeRange: [],
      timeRangeFields: [
        {key: 'tr_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'range', label: this.$i18n.t('Range'), sortable: true},
        {key: 'priority', label: this.$i18n.t('Priority'), sortable: true}
      ],
      deleteImage: require('@/assets/img/document_delete.png'),
      payment: {
        name: '',
        id: 0,
        isResetBalance: false,
        sum: 0,
        reason: '',
        currency: 810,
        inType: 0
      },
      banksFields: [
        {key: 'bank_id', label: 'ID', sortable: true},
        {key: 'bic', label: this.$i18n.t('BIN'), sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'city', label: this.$i18n.t('City'), sortable: true}
      ],
      selectedBank: null,
      bank: {
        bic: '',
        city: '',
        name: '',
        kschet: ''
      },
      telDirectionsFields: [
        {key: 'dir_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'create_date', label: this.$i18n.t('Created on'), sortable: true},
        {key: 'update_date', label: this.$i18n.t('Updated on'), sortable: true},
        {key: 'zones', label: this.$i18n.t('Zone'), sortable: true},
        {key: 'calling_prefix', label: this.$i18n.t('Calling prefix'), sortable: true},
        {key: 'called_prefix', label: this.$i18n.t('Called prefix'), sortable: true}
      ],
      telZonesFields: [
        {key: 'zone_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'create_date', label: this.$i18n.t('Created on'), sortable: true},
        {key: 'update_date', label: this.$i18n.t('Updated on'), sortable: true},
        {key: 'supplier_id', label: this.$i18n.t('Supplier id'), sortable: true}
      ]
    }
  },
  methods: {
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (!this.serviceParam.tel_service_data.cost_info.second_period_step) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Next period step fields is invalid'), 'Error')
        return
      }
      if (!this.serviceParam.tel_service_data.cost_info.time_unit_size) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Tariffcication unit size fields is invalid'), 'Error')
        return
      }
      if (!this.costTable.length) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Price editor table is empty'), 'Error')
        return
      }

      let tmpService = {
        'supplier_id': 0,
        'tel_service_data': {
          'cost_table': [],
          'free_time': 0,
          'first_period_length': 0,
          'first_period_step': 0,
          'second_period_step': 0,
          'time_unit_size': 0,
          'discount_free_time': true
        }
      }
      tmpService.tel_service_data.time_unit_size = Number(this.serviceParam.tel_service_data.cost_info.time_unit_size)
      tmpService.tel_service_data.second_period_step = Number(this.serviceParam.tel_service_data.cost_info.second_period_step)
      if (this.serviceParam.tel_service_data.cost_info.free_time) {
        tmpService.tel_service_data.free_time = Number(this.serviceParam.tel_service_data.cost_info.free_time)
      } else {
        tmpService.tel_service_data.free_time = 0
      }
      if (this.serviceParam.tel_service_data.cost_info.first_period_length) {
        tmpService.tel_service_data.first_period_length = Number(this.serviceParam.tel_service_data.cost_info.first_period_length)
      } else {
        tmpService.tel_service_data.first_period_length = 0
      }
      if (this.serviceParam.tel_service_data.cost_info.first_period_step) {
        tmpService.tel_service_data.first_period_step = Number(this.serviceParam.tel_service_data.cost_info.first_period_step)
      } else {
        tmpService.tel_service_data.first_period_step = 0
      }
      tmpService.tel_service_data.cost_table = this.costTable
      for (let el of tmpService.tel_service_data.cost_table) {
        for (let elBorder of el.cost_info.borders) {
          elBorder.border = Number(elBorder.border)
          elBorder.cost_coefficient = Number(elBorder.cost_coefficient)
        }
      }
      for (let el of tmpService.tel_service_data.cost_table) {
        for (let elCost of el.cost_info.costs) {
          elCost.cost = Number(elCost.cost)
        }
      }
      for (let elFixed of this.fixedRoll) {
        for (let el of tmpService.tel_service_data.cost_table) {
          if (elFixed.tariff_key === el.tariff_key) {
            el.cost_info.fixed_cost = Number(elFixed.cost_info.fixed_cost)
          }
        }
      }

      if (this.editItem.id) {
        this.editItem.supplier_id = this.editItem.id
        let response = this.$store.dispatch('Settings/UPDATE_TELEPHONE_SUPPLIER', this.editItem)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            tmpService.supplier_id = this.editItem.id
            let responseService = this.$store.dispatch('Settings/UPDATE_TELEPHONE_SUPPLIER_SERVICE', tmpService)
            responseService.then(responseService => {
              if (responseService.data.error) {
                this.$root.$emit('makeToasts', 'danger', responseService.data.error, 'Error')
              } else {
                setTimeout(this.$store.dispatch, 500, 'Settings/GET_TELEPHONE_OPERATORS')
                this.$refs.modalTelephoneOperators.hide()
                this.$root.$emit('makeToasts')
              }
            })
          }
        })
      } else {
        let response = this.$store.dispatch('Settings/CREATE_TELEPHONE_SUPPLIER', this.editItem)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            tmpService.supplier_id = response.data.supplier_id
            let responseService = this.$store.dispatch('Settings/CREATE_TELEPHONE_SUPPLIER_SERVICE', tmpService)
            responseService.then(responseService => {
              if (responseService.data.error) {
                this.$root.$emit('makeToasts', 'danger', responseService.data.error, 'Error')
              } else {
                setTimeout(this.$store.dispatch, 500, 'Settings/GET_TELEPHONE_OPERATORS')
                this.$refs.modalTelephoneOperators.hide()
                this.$root.$emit('makeToasts')
              }
            })
          }
        })
      }
    },
    async shown () {
      this.costTimeRange = []
      this.fixedRoll = []
      this.costTable = []
      this.bank.bic = ''
      this.bank.city = ''
      this.bank.name = ''
      this.bank.kschet = ''
      if (this.editItem.id) {
        await this.$store.dispatch('Settings/GET_CURRENT_SUPPLIER', this.editItem.id)
        await this.$store.dispatch('Settings/GET_SUPPLIER_SERVICE', this.editItem.id)

        this.editItem.contract_number = this.currentSupplier.contract_number
        this.editItem.contract_place = this.currentSupplier.contract_place
        this.editItem.number_format = this.currentSupplier.number_format
        this.editItem.client_prefix = this.currentSupplier.client_prefix
        this.editItem.service_place = this.currentSupplier.service_place
        this.editItem.balance = this.currentSupplier.balance
        if (this.editItem.bank_id !== 0) {
          for (let el of this.banks) {
            if (el.bank_id === this.editItem.bank_id) {
              this.bank.bic = el.bic
              this.bank.city = el.city
              this.bank.name = el.name
              this.bank.kschet = el.kschet
            }
          }
        }
        let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/TELEPHONE_OPERATORS_SERVICE']))
        this.costTimeRange = JSON.parse(JSON.stringify(copy.tel_service_data.cost_info.cost_table[0].cost_info.costs))
        for (let el of this.costTimeRange) {
          for (let elTimeRange of this.timeRangeList) {
            if (el.time_range_id === elTimeRange.tr_id) {
              el.nameTimeRange = elTimeRange.name
            }
          }
        }
        this.borId = 0
        this.costTable = JSON.parse(JSON.stringify(copy.tel_service_data.cost_info.cost_table))
        for (let el of this.costTable) {
          for (let elBor of el.cost_info.borders) {
            elBor.num = ++this.borId
          }
          if (el.tariff_key >= 1000000) {
            for (let elDir of this.telDirectionsItems) {
              if (el.tariff_key === elDir.dir_id) {
                el.nameTel = elDir.name
              }
            }
          } else {
            for (let elZon of this.telZonesItems) {
              if (el.tariff_key === elZon.zone_id) {
                el.nameTel = elZon.name
              }
            }
          }
        }
        let arr = JSON.parse(JSON.stringify(this.costTable))
        for (let el of arr) {
          if (el.cost_info.fixed_cost) {
            this.fixedRoll.push(el)
          }
        }
      }
    },
    showBank () {
      this.selectedBank = null
      this.$root.$emit('bv::show::modal', 'modalBank', '#btnShow')
    },
    onRowSelected (selected) {
      this.selectedBank = selected[0]
    },
    selectBank () {
      this.editItem.bank_id = this.selectedBank.bank_id
      this.bank.bic = this.selectedBank.bic
      this.bank.city = this.selectedBank.city
      this.bank.name = this.selectedBank.name
      this.bank.kschet = this.selectedBank.kschet
      this.$refs.modalBank.hide()
    },
    showPayment () {
      this.payment = {
        name: '',
        id: 0,
        isResetBalance: false,
        sum: 0,
        reason: '',
        currency: 810,
        inType: 0
      }
      this.payment.name = this.editItem.name
      this.payment.id = this.editItem.id
      this.$root.$emit('bv::show::modal', 'modalPayment', '#btnShow')
    },
    resetBalance () {
      this.payment.sum = 0
    },
    savePayment () {
      if (!Number(this.payment.sum)) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Sum fields is invalid'), 'Error')
        return
      }
      if (this.payment.sum <= 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Sum fields is invalid'), 'Error')
        return
      }

      if (this.payment.isResetBalance) {
        this.payment.inType = 1
      }
      let response = this.$store.dispatch('Settings/GET_MAKE_PAYMENT_FOR_SUPPLIER', this.payment)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.editItem.balance += response.data.absolute_sum
          this.$refs.modalPayment.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    showAddTimeRange () {
      this.rowTimeRange = null
      this.$refs.modalTimeRange.show()
    },
    rowClickTimeRange (row) {
      this.rowTimeRange = row
    },
    addTimeRange () {
      if (!this.rowTimeRange) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select time range'), 'Error')
        return
      }
      for (let el of this.costTimeRange) {
        if (el.time_range_id === this.rowTimeRange.tr_id) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more time range for same id'), 'Error')
          return
        }
      }
      this.rowTimeRange.cost = 0
      this.rowTimeRange.nameTimeRange = this.rowTimeRange.name
      this.rowTimeRange.time_range_id = this.rowTimeRange.tr_id
      this.costTimeRange.push(JSON.parse(JSON.stringify(this.rowTimeRange)))
      for (let curCostTable of this.costTable) {
        curCostTable.cost_info.costs.push(JSON.parse(JSON.stringify(this.rowTimeRange)))
        this.$set(curCostTable.cost_info, 'costs', curCostTable.cost_info.costs)
      }

      this.$refs.modalTimeRange.hide()
    },
    showAddTelDirections () {
      this.rowTelDirections = null
      this.isBorder = false
      this.isFixed = false
      this.$refs.modalTelDirections.show()
    },
    showAddTelDirBorder () {
      this.isBorder = true
      this.isFixed = false
      this.rowTelDirections = null
      this.$refs.modalTelDirections.show()
    },
    showAddTelDirFixed () {
      this.isBorder = false
      this.isFixed = true
      this.rowTelDirections = null
      this.$refs.modalTelDirections.show()
    },
    showAddTelZones () {
      this.isBorder = false
      this.isFixed = false
      this.rowTelZones = null
      this.$refs.modalTelZones.show()
    },
    showAddTelZonesBorder () {
      this.isBorder = true
      this.isFixed = false
      this.rowTelZones = null
      this.$refs.modalTelZones.show()
    },
    showAddTelZonesFixed () {
      this.isBorder = false
      this.isFixed = true
      this.rowTelZones = null
      this.$refs.modalTelZones.show()
    },
    rowClickTelDirections (row) {
      this.rowTelDirections = row
    },
    rowClickTelZones (row) {
      this.rowTelZones = row
    },
    addTelDirections () {
      if (!this.rowTelDirections) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select telephone direction'), 'Error')
        return
      }
      if (this.isBorder || this.isFixed) {
        let isBoolean = this.costTable.find(el => {
          return el.tariff_key === this.rowTelDirections.dir_id
        })
        if (isBoolean) {
          if (this.isBorder) {
            let newBorder = {
              'border': 0,
              'cost_coefficient': 1,
              'num': 0
            }
            for (let el of this.costTable) {
              if (el.tariff_key === this.rowTelDirections.dir_id) {
                newBorder.num = ++this.borId
                el.cost_info.borders.push(newBorder)
              }
            }
          }
          if (this.isFixed) {
            for (let el of this.fixedRoll) {
              if (el.tariff_key === this.rowTelDirections.dir_id) {
                this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
                return
              }
            }
            let newFixed = {
              'nameTel': '',
              'tariff_key': 0,
              'cost_info': {
                'fixed_cost': 0
              }
            }
            newFixed.nameTel = this.rowTelDirections.name
            newFixed.tariff_key = this.rowTelDirections.dir_id
            this.fixedRoll.push(newFixed)
          }
        } else {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Not in the table price'), 'Error')
          return
        }
      } else {
        for (let i in this.costTable) {
          if (this.costTable[i].tariff_key === this.rowTelDirections.dir_id) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
            return
          }
        }
        let newCostTable = {
          'tariff_key': 0,
          'nameTel': '',
          'cost_info': {
            'borders': [
              {
                'border': 0,
                'cost_coefficient': 1,
                'num': 0
              }
            ],
            'costs': [],
            'prepaid': 0,
            'fixed_cost': 0
          }
        }
        newCostTable.cost_info.borders[0].num = ++this.borId
        newCostTable.nameTel = this.rowTelDirections.name
        newCostTable.tariff_key = this.rowTelDirections.dir_id
        newCostTable.cost_info.costs = JSON.parse(JSON.stringify(this.costTimeRange))
        this.costTable.push(newCostTable)
      }
      this.$refs.modalTelDirections.hide()
    },
    addTelZones () {
      if (!this.rowTelZones) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select telephone zone'), 'Error')
        return
      }
      if (this.isBorder || this.isFixed) {
        let isBoolean = this.costTable.find(el => {
          return el.tariff_key === this.rowTelZones.zone_id
        })
        if (isBoolean) {
          if (this.isBorder) {
            let newBorder = {
              'border': 0,
              'cost_coefficient': 1,
              'num': 0
            }
            for (let el of this.costTable) {
              if (el.tariff_key === this.rowTelZones.zone_id) {
                newBorder.num = ++this.borId
                el.cost_info.borders.push(newBorder)
              }
            }
          }
          if (this.isFixed) {
            for (let i in this.fixedRoll) {
              if (this.fixedRoll[i].tariff_key === this.rowTelZones.zone_id) {
                this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
                return
              }
            }
            let newFixed = {
              'nameTel': '',
              'tariff_key': 0,
              'cost_info': {
                'fixed_cost': 0
              }
            }
            newFixed.nameTel = this.rowTelZones.name
            newFixed.tariff_key = this.rowTelZones.zone_id
            this.fixedRoll.push(newFixed)
          }
        } else {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Not in the table price'), 'Error')
          return
        }
      } else {
        for (let el of this.costTable) {
          if (el.tariff_key === this.rowTelZones.zone_id) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
            return
          }
        }
        let newCostTable = {
          'tariff_key': 0,
          'nameTel': '',
          'cost_info': {
            'borders': [
              {
                'border': 0,
                'cost_coefficient': 1,
                'num': 0
              }
            ],
            'costs': [],
            'prepaid': 0,
            'fixed_cost': 0
          }
        }
        newCostTable.cost_info.borders[0].num = ++this.borId
        newCostTable.nameTel = this.rowTelZones.name
        newCostTable.tariff_key = this.rowTelZones.zone_id
        newCostTable.cost_info.costs = JSON.parse(JSON.stringify(this.costTimeRange))
        this.costTable.push(newCostTable)
      }
      this.$refs.modalTelZones.hide()
    },
    deleteTimeRange (item) {
      this.costTimeRange = this.costTimeRange.filter((value) => {
        return value.time_range_id !== item.time_range_id
      })
      for (let curTable of this.costTable) {
        curTable.cost_info.costs = curTable.cost_info.costs.filter((value) => {
          return value.time_range_id !== item.time_range_id
        })
      }
    },
    deleteCost (item) {
      this.costTable = this.costTable.filter((value) => {
        return value.tariff_key !== item.tariff_key
      })
    },
    deleteFixed (item) {
      this.fixedRoll = this.fixedRoll.filter((value) => {
        return value.tariff_key !== item.tariff_key
      })
    },
    deleteBorder (item) {
      for (let el of this.costTable) {
        el.cost_info.borders = el.cost_info.borders.filter((value) => {
          return value.num !== item.num
        })
      }
    }
  },
  computed: {
    currencies () {
      let res = []
      for (let el of this.$store.getters['ReferenceBooks/CURRENCIES']) {
        let newEl = {}
        newEl.value = el.currency_id.toString()
        newEl.text = el.currency_brief_name
        res.push(newEl)
      }
      return res
    },
    currentSupplier () {
      return this.$store.getters['Settings/CURRENT_SUPPLIER']
    },
    timeRangeList () {
      return this.$store.getters['Tariffing/TIME_RANGE']
    },
    telDirectionsItems () {
      return this.$store.getters['Tariffing/TEL_DIRECTIONS']
    },
    telZonesItems () {
      return this.$store.getters['Tariffing/TEL_ZONES']
    },
    banks () {
      return this.$store.getters['ReferenceBooks/BANKS']
    },
    serviceParam () {
      let serviceParam = {
        tel_service_data: {
          cost_info: {
            free_time: '',
            first_period_length: '',
            first_period_step: '',
            second_period_step: 1,
            time_unit_size: 60
          }
        }
      }
      if (this.editItem.id) {
        serviceParam = this.$store.getters['Settings/TELEPHONE_OPERATORS_SERVICE']
      }
      return serviceParam
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/telephony/telephoneOperators/editModal.vue